import React, {useContext, useEffect, useState} from 'react';
import {
    Typography,
    makeStyles
} from '@material-ui/core';
import { useTranslation } from "react-i18next";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from "@material-ui/core/Grid";
import getApiRoute from "../../../routes/apiRoutes";
import SecureFetchContext from "../../../context/SecureFetchContext";

const useStyles = makeStyles(() => ({
    root: {}
}));

const AddressPreview = ({ className, prefix, values, title, rightCorner=null,...rest }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const secureFetch = useContext(SecureFetchContext);
    const [carriers, setCarriers] = useState([]);

    useEffect( () => {
        if (carriers.length === 0 && prefix === 'receiver_' && values.others && values.others.carrier_type) {
            secureFetch(getApiRoute('carrier_available')).then(json => {
                setCarriers(json);
            });
        }
    }, [values]);


    return (
        <Table className={classes.table} size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell colSpan={2}>
                        <Grid container justify='space-between'>
                            <Grid item>
                                <Typography component="h3" color="primary">
                                    {title}
                                </Typography>
                            </Grid>
                            {
                                !!rightCorner &&
                                <Grid item>
                                    <Typography component="h4" color="primary">
                                        {rightCorner}
                                    </Typography>
                                </Grid>
                            }
                        </Grid>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.name')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'name']}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {values.parcelshop && prefix === 'receiver_' ? t('label.parcelshop') : t('label.company')}
                    </TableCell>
                    <TableCell>
                        {values.parcelshop && prefix === 'receiver_' ? `${values[prefix + 'company']} (ID: ${values.parcelshop})` : values[prefix + 'company']}
                    </TableCell>
                </TableRow>
                {carriers.find(option => option.packeta_id === values.others.carrier_type) &&
                    <TableRow>
                        <TableCell component="th" variant="head">
                            {t('label.carrier_type')}
                        </TableCell>
                        <TableCell>
                            {carriers.find(option => option.packeta_id === values.others.carrier_type).name}
                        </TableCell>
                    </TableRow>
                }
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.street')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'street']}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.city')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'city']}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.house_number')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'house_number']}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.zip')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'zip']}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.state')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'state_code']}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.email')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'email']}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell component="th" variant="head">
                        {t('label.phone')}
                    </TableCell>
                    <TableCell>
                        {values[prefix + 'phone']}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default AddressPreview;
